export default __webpack_public_path__ + "resources/icons/d120-3c64.png";